import { MileageForm } from "@/components/forms/MileageForm"
import { SettingsLayout } from "@/components/layouts/setting-layout/SettingsLayout"
import { useFormAutoSave } from "@/hooks/useFormAutoSave"
import { MileageFormData } from "@/state/draft/mileage"
import { TimeSpent } from "@/state/draft/timeSpent"
import { PlainDate } from "@/utils/date"
import React from "react"
import { useForm } from "react-hook-form"

type EditMileageScreenProps = {
	reportId: string
	onSave: (data: { mileage: MileageFormData; timeSpent: TimeSpent }) => void
	onSaveLocal: (data: { mileage: MileageFormData; timeSpent: TimeSpent }) => void
	timeSpent: TimeSpent
	mileage: MileageFormData
	savingInProcess: boolean
	dateRange: [PlainDate, PlainDate]
}

export const EditMileageScreen: React.FC<EditMileageScreenProps> = (props) => {
	const mileageForm = useForm<MileageFormData>({
		defaultValues: props.mileage,
	})
	const timeSpentForm = useForm<TimeSpent>({
		defaultValues: props.timeSpent,
	})
	useFormAutoSave(
		mileageForm.control,
		(data) =>
			props.onSaveLocal({ mileage: data, timeSpent: timeSpentForm.getValues() }),
		props.mileage
	)
	useFormAutoSave(
		timeSpentForm.control,
		(data) =>
			props.onSaveLocal({ timeSpent: data, mileage: mileageForm.getValues() }),
		props.timeSpent
	)
	return (
		<SettingsLayout
			savingInProcess={props.savingInProcess}
			reportId={props.reportId}
			title="Miles and time Settings"
			description="To improve the accuracy of your report, enter the details about your trips"
			activeSection="miles-time"
			onSave={async () => {
				const isFirstFormValid = await mileageForm.trigger()
				const isSecondFormValid = await timeSpentForm.trigger()

				if (!(isFirstFormValid && isSecondFormValid)) {
					return
				}
				props.onSave({
					mileage: mileageForm.getValues(),
					timeSpent: timeSpentForm.getValues(),
				})
			}}
		>
			<MileageForm
				dateRange={props.dateRange}
				form={mileageForm}
				timeSpentForm={timeSpentForm}
				advancedFormEnabled={true}
			/>
		</SettingsLayout>
	)
}
